export enum DeviceStageEnum {
  ALL = 0,
  USERS = 1,
}
